import creteleadtext from "../../../assets/icons/creteleadtext.svg";
import creteleadvoice from "../../../assets/icons/creteleadvoice.svg";
import { routes } from "../../../constants/routes";
import uploadArrow from "../../../assets/icons/upload-arrow.svg";
import uploadLink from "../../../assets/icons/link-url.svg";

export const filterOptions = [
  {
    labels: "First Name",
    value: false,
  },
  {
    labels: "Last Name",
    value: false,
  },
  {
    labels: "Email",
    value: false,
  },
  {
    labels: "Company",
    value: false,
  },
  {
    labels: "Lead Source",
    value: false,
  },
  {
    labels: "Customer Owner",
    value: false,
  },
  {
    labels: "Date of Birth",
    value: false,
  },
  // {
  //   labels: "Converted Contact",
  //   value: false,
  // },
  // {
  //   labels: "Converted Account",
  //   value: false,
  // },
  // {
  //   labels: "Converted Deal",
  //   value: false,
  // },
  // {
  //   labels: "Email Opt Out",
  //   value: false,
  // },
];
export const CREATED_TIME_OPTIONS = [
  { label: "Today", value: "Today" },
  { label: "Yesterday", value: "Yesterday" },
  { label: "This Week", value: "This Week" },
  { label: "This Month", value: "This Month" },
  { label: "Last Week", value: "Last Week" },
  { label: "Last Month", value: "Last Month" },
  { label: "Custom", value: "Custom" },
];

export const allCustomersOptions = [
  { value: "All Customers", id: 0, styleName: "bold-option" },
  { value: "Converted Customers", id: 1 },
  { value: "My Converted Customers", id: 2 },
  { value: "My Customers", id: 3 },
  { value: "Not Qualified Customers", id: 4 },
  { value: "Open leads", id: 5 },
  { value: "Recently Modified Customers", id: 6 },
  { value: "Today’s Customers", id: 7 },
];

export const createCustomersOptions = [
  { value: "Import Customers", id: 1 },
  // { value: "Social Media Import", id: 2 },
];

export const createCustomersButtonOptions = (
  setIsShowCreateCustomer: any,
  isShowCreateCustomer: any,
  isShowCreateCustomerSection: any,
  setIsShowCreateCustomerSection: any
) => {
  return [
    {
      value: "Text",
      id: 1,
      icon: creteleadtext,
      onClick: () => {
        setIsShowCreateCustomerSection(!isShowCreateCustomerSection);
      },
    },
    {
      value: "Voice",
      id: 2,
      icon: creteleadvoice,
      onClick: () => {
        setIsShowCreateCustomer(!isShowCreateCustomer);
      },
    },
  ];
};

export const actionsOptions = [
  { value: "Archive", id: 1 },
  { value: "Update", id: 2 },
  // { value: "Convert", id: 3 },
  // { value: "Email", id: 4 },
  { value: "Export Customers", id: 5 },
  // { value: "Add to Campaigns", id: 6 },
];

export const leadActionScope = [
  { value: "All Customers" },
  { value: "Selected Customers" },
];

export const leadEditableFields = [
  { label: "Customer Value", id: 1, value: "leadValue" },
  { label: "Confidence Score", id: 3, value: "confidenceScore" },
  { label: "Description", id: 4, value: "description" },
  { label: "Fax Number", id: 5, value: "faxNumber" },
  { label: "Industry", id: 6, value: "industry" },
  { label: "Interested Product", id: 7, value: "interestedProducts" },
  { label: "Customer Owner", id: 8, value: "leadOwner" },
  { label: "Customer Status", id: 10, value: "leadStatus" },
  { label: "Social Customer ID", id: 12, value: "socialCustomerId" },
  { label: "Website URL", id: 13, value: "website" },
];

export const uploadAttachmentsOptions = [
  {
    label: "Upload Files",
    value: "uploadFile",
    id: 1,
    icon: uploadArrow,
  },
  {
    label: "Link URL",
    value: "linkUrl",
    id: 2,
    icon: uploadLink,
  },
];
